module.exports = __webpack_public_path__ + "img/filter.7d9b800a.png";